import { FunctionComponent, useEffect, useState } from "react";

import { colors } from "@story/data-centers-hub/config/colors";
import VergeLogo from "@voxmedia/duet-ui/components/brand/theverge/VergeLogo";

import * as styles from "./ArticleLoadingFallback.css";

const LOADING_SEQUENCE = ["loading .", "loading ..", "loading ..."];
const SEQUENCE_INTERVAL_MS = 400;

/**
 * Suspense fallback: Verge logo + animated loading dots (visual only).
 */
const ArticleLoadingFallback: FunctionComponent = () => {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStep((prev) => (prev + 1) % LOADING_SEQUENCE.length);
    }, SEQUENCE_INTERVAL_MS);
    return () => clearInterval(id);
  }, []);

  return (
    <div className={styles.container} aria-busy="true">
      <span className="sr-only">Loading</span>
      <span aria-hidden="true">
        <VergeLogo className={styles.logo} fill={colors.text} />
      </span>
      <p className={styles.text} aria-hidden="true">
        {LOADING_SEQUENCE[step]}
      </p>
    </div>
  );
};

export default ArticleLoadingFallback;
